<script lang="ts">
  import { listBuilds, type BuildRow } from "../lib/api";

  let builds = $state<BuildRow[]>([]);
  let error = $state<string | null>(null);
  let loading = $state(true);
  let filterRepo = $state("");
  let filterBranch = $state("");

  async function load() {
    loading = true;
    error = null;
    try {
      const r = await listBuilds({
        repo: filterRepo || undefined,
        branch: filterBranch || undefined,
        limit: 50,
      });
      builds = r.builds;
    } catch (e) {
      error = String(e);
    } finally {
      loading = false;
    }
  }

  $effect(() => {
    load();
  });

  function fmt(ts: number) {
    return new Date(ts).toLocaleString();
  }
  function verdict(b: BuildRow) {
    if (b.changed_count + b.added_count + b.removed_count === 0) return "clean";
    return `${b.changed_count}c / ${b.added_count}+ / ${b.removed_count}-`;
  }
</script>

<section>
  <h2>Recent builds</h2>
  <div class="filters">
    <label>
      repo
      <input bind:value={filterRepo} placeholder="platform" onblur={load} />
    </label>
    <label>
      branch
      <input bind:value={filterBranch} placeholder="main" onblur={load} />
    </label>
    <button onclick={load}>refresh</button>
  </div>
  {#if loading}
    <p class="muted">loading…</p>
  {:else if error}
    <p class="err">{error}</p>
  {:else if builds.length === 0}
    <p class="muted">no builds yet. <code>nvr upload</code> writes here.</p>
  {:else}
    <table>
      <thead>
        <tr>
          <th>build</th>
          <th>repo</th>
          <th>branch</th>
          <th>sha</th>
          <th>pr</th>
          <th>status</th>
          <th>diff</th>
          <th>when</th>
        </tr>
      </thead>
      <tbody>
        {#each builds as b (b.id)}
          <tr>
            <td><a href={`#/builds/${b.id}`}>{b.id.slice(0, 24)}…</a></td>
            <td>{b.repo}</td>
            <td>{b.branch}</td>
            <td><code>{b.sha.slice(0, 8)}</code></td>
            <td>{b.pr_number ?? ""}</td>
            <td><span class={`pill ${b.status}`}>{b.status}</span></td>
            <td>{verdict(b)}</td>
            <td class="muted">{fmt(b.triggered_at)}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</section>

<style>
  h2 {
    margin: 0 0 12px;
    font-size: 18px;
  }
  .filters {
    display: flex;
    gap: 12px;
    align-items: flex-end;
    margin-bottom: 16px;
  }
  .filters label {
    display: flex;
    flex-direction: column;
    font-size: 11px;
    color: #6b7180;
  }
  .filters input {
    background: #1c2230;
    border: 1px solid #2a3142;
    border-radius: 6px;
    padding: 6px 8px;
    color: #e6e8ee;
    min-width: 140px;
  }
  .filters button {
    background: #1c2230;
    border: 1px solid #2a3142;
    border-radius: 6px;
    padding: 6px 12px;
    color: #e6e8ee;
    cursor: pointer;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }
  th,
  td {
    text-align: left;
    padding: 8px 10px;
    border-bottom: 1px solid #1c2230;
  }
  th {
    color: #6b7180;
    font-weight: 500;
    font-size: 11px;
    text-transform: uppercase;
  }
  .muted {
    color: #6b7180;
  }
  .err {
    color: #ff7c7c;
  }
  .pill {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    background: #1c2230;
  }
  .pill.uploaded { background: #2a3142; }
  .pill.captured { background: #1f3a5f; color: #9fcfff; }
  .pill.reviewed { background: #1f5f3a; color: #9fffc0; }
  .pill.accepted { background: #1f5f3a; color: #9fffc0; }
  code {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 12px;
  }
</style>
